import React from 'react';
import LegalPageLayout from '../layouts/LegalPageLayout';
import SEO from '../components/SEO';

const SECTIONS = [
    { id: 'definitions',  label: 'Definitions & Key Terms' },
    { id: 'policy',       label: 'Return & Refund Policy' },
    { id: 'refunds',      label: 'Refunds' },
    { id: 'offline',      label: 'Offline Meetings' },
    { id: 'consent',      label: 'Your Consent' },
    { id: 'changes',      label: 'Changes to This Policy' },
    { id: 'contact',      label: 'Contact Us' },
];

const h2 = { fontSize: '1.2rem', fontWeight: '800', color: '#1A1A2E', margin: '0 0 12px', fontFamily: 'Calibri, sans-serif' };
const divider = { borderTop: '2px solid rgba(173,20,87,0.1)', margin: '0 0 24px' };
const p = { color: '#475569', lineHeight: '1.8', marginBottom: '12px', fontFamily: 'Calibri, sans-serif' };
const li = { color: '#475569', lineHeight: '2', fontFamily: 'Calibri, sans-serif' };
const section = { marginBottom: '44px', scrollMarginTop: '90px' };

const ReturnRefundPolicy = () => (
    <>
        <SEO
            title="Return & Refund Policy"
            description="Understand Oottan's refund and cancellation policy for premium membership plans."
            canonical="/return-refund-policy"
        />
        <LegalPageLayout
            title="Return & Refund Policy"
            updated="10 Oct 2026"
            sections={SECTIONS}
            currentPath="/return-refund-policy"
        >
        <div id="definitions" style={section}>
            <h2 style={h2}>Definitions and Key Terms</h2>
            <hr style={divider} />
            <p style={p}>To help explain things as clearly as possible, every time any of these terms are referenced they are strictly defined as:</p>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={li}><strong>Company:</strong> Refers to <strong>Hirehike Technologies Private Limited, 8/61/1, Kumbavilai, Veeyanoor – 629177, Kanyakumari District, Tamil Nadu, India</strong>.</li>
                <li style={li}><strong>Customer:</strong> The company, organisation, or person that signs up to use the Service to manage the relationships with your consumers or service users.</li>
                <li style={li}><strong>Device:</strong> Any internet-connected device such as a phone, tablet, or computer that can be used to visit Oottan and use the services.</li>
                <li style={li}><strong>Service:</strong> The matrimony services provided by Oottan as described on this platform.</li>
                <li style={li}><strong>Website:</strong> Oottan, accessible via <a href="https://oottan.com" style={{ color: '#AD1457' }}>https://oottan.com</a>.</li>
                <li style={li}><strong>You:</strong> A person or entity registered with Oottan to use the Services.</li>
            </ul>
        </div>

        <div id="policy" style={section}>
            <h2 style={h2}>Return &amp; Refund Policy</h2>
            <hr style={divider} />
            <p style={p}>
                Thanks for using Oottan. We appreciate the fact that you trust us to help you find your
                perfect life partner. We also want to make sure you have a rewarding experience while you're
                exploring, evaluating, and using our matrimony services.
            </p>
            <p style={p}>
                As with any matrimony service, there are terms and conditions that apply to transactions at Oottan.
                The main thing to remember is that by using our matrimony services or making a purchase,
                you agree to the terms set forth below along with Oottan's Privacy Policy.
            </p>
            <p style={p}>
                If there's something wrong with the service you received, or if you are not happy with it, you have
                the option to issue a refund request. To do so, please follow the guidelines listed in this policy.
            </p>
        </div>

        <div id="refunds" style={section}>
            <h2 style={h2}>Refunds</h2>
            <hr style={divider} />
            <p style={p}>
                Oottan is committed to serving our members with the best matrimony services. Every single
                service that you choose is thoroughly designed, tested for quality, and delivered with the utmost
                care — to ensure that you have the best experience finding your life partner.
            </p>
            <p style={p}>
                Sadly, there are times when we may not be able to provide the matrimony service(s) that you chose,
                or may face some issues with our service delivery and quality check. In such cases we may have to
                cancel your subscription or service. You will be informed about it in advance. If you have purchased
                via online payment, you will be refunded once our team confirms your request.
            </p>
            <p style={p}>
                We carry out thorough quality checks before processing any matrimony service. Please note that
                Oottan is not liable for any issues that may arise from offline meetings or personal
                interactions between members.
            </p>
            <p style={p}>
                We will review your refund request as soon as we receive it and, if it follows the guidelines
                addressed above, we will proceed to issue a refund. Your refund may take{' '}
                <strong>5 to 10 business days</strong> to process, but you will be notified when you receive
                your money.
            </p>
        </div>

        <div id="offline" style={section}>
            <h2 style={h2}>Offline Meetings and Interactions</h2>
            <hr style={divider} />
            <p style={p}>
                Oottan is not responsible for any costs associated with offline meetings or personal
                interactions between members. All offline meetings and arrangements are at the discretion and
                responsibility of the members themselves.
            </p>
        </div>

        <div id="consent" style={section}>
            <h2 style={h2}>Your Consent</h2>
            <hr style={divider} />
            <p style={p}>
                By using our platform, registering an account, or making a purchase, you hereby consent to our
                Return &amp; Refund Policy and agree to its terms.
            </p>
        </div>

        <div id="changes" style={section}>
            <h2 style={h2}>Changes to Our Return &amp; Refund Policy</h2>
            <hr style={divider} />
            <p style={p}>
                We may update, amend, or make any changes to this document so that they accurately reflect our
                Service and policies. Unless otherwise required by law, those changes will be prominently posted
                here. If you continue to use the Service after changes are made, you will be bound by the updated
                Return &amp; Refund Policy.
            </p>
        </div>

        <div id="contact" style={section}>
            <h2 style={h2}>Contact Us</h2>
            <hr style={divider} />
            <p style={p}>Don't hesitate to contact us if you have any questions about this Return &amp; Refund Policy.</p>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={li}>Email: <strong>info@oottan.com</strong></li>
                <li style={li}>Phone: <strong>04651-215020</strong></li>
                <li style={li}>Address: <strong>8/61/1, Kumbavilai, Veeyanoor – 629177, Kanyakumari District, Tamil Nadu, India</strong></li>
            </ul>
        </div>
        </LegalPageLayout>
    </>
);

export default ReturnRefundPolicy;
